export const CATEGORIES_EVENTS = {
  SET_PRICES: 'setPrices',
  SHOW_MODAL: 'showModal',
  HIDE_MODAL: 'hideModal',
  ADD: 'add',
};

export const HELP_EVENTS = {
  UPDATE: 'update',
};

export const META_EVENTS = {
  INIT: 'init',
  CHANGE_SECTOR: 'changeSector',
  SELECT_DATE: 'selectDate',
  SET_SELECTED_DATE: 'setSelectedDate',
};

export const NOTIFICATION_EVENTS = {
  UPDATE: 'update',
};

export const PRICES_EVENTS = {
  UPDATE: 'update',
  TOGGLE_PRICE: 'togglePrice',
  PRICES_PREVIEW_UPDATED: 'pricesPreviewUpdated',
};

export const TICKETS_EVENTS = {
  TOGGLE_ORDER_FORM: 'toggleOrderForm',
  INIT_TICKETS: 'initTickets',
  SET_PRICES: 'setPrices',
  RENDER_TICKETS: 'renderTickets',
  CHECK_ERROR: 'checkError',
  CHANGE: 'change',
  ADD: 'add',
  REMOVE: 'remove',
  SHOW_TICKETS_COUNT_MODAL: 'showTicketsCountModal',
  SET_NEW_SELECTED_TICKETS: 'setNewSelectedTickets',
  UPDATE_COUNT: 'updateCount',
  CLEAR_QUANTITY_ANNOUNCEMENT: 'clearQuantityAnnouncement',
};

export const TICKETS_POPOVER_EVENTS = {
  UPDATE: 'update',
};

export const WIDGET_EVENTS = {
  INIT_TICKETS: 'initTickets',
  RENDER_TICKETS: 'renderTickets',
  SET_PRICES: 'setPrices',
  SCHEME_MODE_CHANGE: 'schemeModeChange',
  RERENDER: 'rerender',
  RELOAD_TICKETS: 'reloadWidget',
};

export const ZOOM_EVENTS = {
  UPDATE: 'update',
  ZOOM_START: 'zoomStart',
  TWO_FINGERS_ZOOM_START: 'twoFingersZoomStart',
  TWO_FINGERS_ZOOM_END: 'twoFingersZoomEnd',
  UPDATED_FROM_THE_BUTTON: 'updateFromTheButton',
};

export const SIDEBAR_EVENTS = {
  SET_POSITION: 'setPosition',
};
